import { useEffect } from "react";
import { AppProviders } from "./providers/AppProviders";
import { RouterWithLoader } from "./navigation/RouterWithLoader";
import { setupFirebasePushNotifications } from "@/features/notifications/firebaseMessaging.service";
import { tokenService } from "@/services/auth/token.service";

export const AppBootstrap = () => {
  useEffect(() => {
    if (!tokenService.hasToken()) return;
    setupFirebasePushNotifications().catch((error: unknown) => {
      console.error("Firebase push setup failed", error);
    });
  }, []);

  return (
    <AppProviders>
      <RouterWithLoader />
    </AppProviders>
  );
};
